import React from 'react'

import Icon from 'app/app/(client)/components/atoms/Icon/Icon'
import Text from 'app/app/(client)/components/atoms/Text/Text'
import { BadgeType, BadgeVariant } from 'app/types/types'
import { BadgeType as cBadgeType, BadgeVariant as cBadgeVariant } from 'app/app/(client)/utils/client-constants'

export interface BadgeProps {
  id: string
  className?: string
  type: BadgeType
  variant?: BadgeVariant
  icon?: string
  label: string
  error?: boolean
  onclick?: (e: React.MouseEvent<HTMLDivElement>) => void
}

const Badge: React.FC<BadgeProps> = ({
  id,
  className,
  variant = cBadgeVariant.NORMAL,
  type = cBadgeType.CATEGORY,
  icon,
  onclick,
  label
}) => (
  <div id={id} className={`badge--${type} ${variant} ${className}`} role={type} onClick={onclick}>
    {icon && <Icon name={icon} className={`${variant}`} />}
    <Text id={`${id}-label`} as="span" className="text-inherit">
      {label}
    </Text>
  </div>
)

export default Badge
